import CancelIcon from '@material-ui/icons/Cancel';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { createMuiTheme } from 'app-modules/application/styles/createMuiTheme';

const muiTheme = createMuiTheme('#000');

export const Dialog = ({ children, ...props }) => (
  <MuiThemeProvider theme={muiTheme}>
    <MuiDialog {...props}>{children}</MuiDialog>
  </MuiThemeProvider>
);
Dialog.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = {
  dialogTitle: {
    backgroundColor: '#fff',
    borderBottom: '1px solid #d4d4d4',
    color: '#000',
    fontWeight: 'bold',
    marginBottom: 20,
    position: 'relative',
  },
  closeButton: {
    cursor: 'pointer',
    fontSize: 25,
    margin: 9,
    opacity: 0.5,
    position: 'absolute',
    right: 0,
    top: 0,
  },
};

const DialogTitleComponent = ({ children, classes, onClose }) => (
  <MuiDialogTitle disableTypography className={classes.dialogTitle}>
    {children}
    <CancelIcon className={classes.closeButton} onClick={onClose} />
  </MuiDialogTitle>
);
DialogTitleComponent.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
};

export const DialogTitle = withStyles(styles)(DialogTitleComponent);
